// extracted by mini-css-extract-plugin
export default {"button":"BurgerMenu_button__dYa5W","open":"BurgerMenu_open__1dlTR","menu":"BurgerMenu_menu__GI52n","overlay":"BurgerMenu_overlay__HiZRU"};